import request from "./axios";

// Admin API-key management. create/rotate return the raw token exactly once.

function index() {
  return request({
    method: "get",
    url: `/api_keys`
  })
}

function create(name, scope) {
  return request({
    method: "post",
    url: `/api_keys`,
    data: { name, scope }
  })
}

function rotate(id) {
  return request({
    method: "post",
    url: `/api_keys/${id}/rotate`
  })
}

function updateScope(id, scope) {
  return request({
    method: "patch",
    url: `/api_keys/${id}`,
    data: { scope }
  })
}

function revoke(id) {
  return request({
    method: "delete",
    url: `/api_keys/${id}`
  })
}

const ApiKeysService = {
  index, create, rotate, revoke, updateScope
};

export default ApiKeysService;
